"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarSecurityStations = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var Size_1 = require("../render/Size");
var CardRequirements_1 = require("../CardRequirements");
var Options_1 = require("../Options");
var LunarSecurityStations = (function (_super) {
    __extends(LunarSecurityStations, _super);
    function LunarSecurityStations() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNAR_SECURITY_STATIONS,
            cardType: CardType_1.CardType.ACTIVE,
            cost: 9,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.roadTiles(3, { all: Options_1.all }); }),
            tr: { moonLogistics: 1 },
            metadata: {
                description: 'Requires 3 road tiles on the Moon. Raise the Logistic Rate 1 step.',
                cardNumber: 'M42',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.text('Opponents may not remove your', Size_1.Size.SMALL, true).br;
                    b.steel(1).titanium(1).production(function (pb) { return pb.steel(1).titanium(1); }).br;
                    b.moonLogisticsRate();
                }),
            },
        }) || this;
    }
    ;
    LunarSecurityStations.prototype.play = function (player) {
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    };
    return LunarSecurityStations;
}(Card_1.Card));
exports.LunarSecurityStations = LunarSecurityStations;
